<script lang="ts">
    import '../../../tailwind.css';
    import Button from '$lib/components/Button/Button.svelte';
    import LazyIcon from '$lib/components/LazyIcon/LazyIcon.svelte';
    export let icon: string;
    export let title: string;
    export let info: string;
    export let buttonText: string | undefined = undefined;
    export let href: string | undefined = undefined;
</script>

<div class="flex h-screen w-screen items-center justify-center bg-grey-0">
    <div
        class="flex flex-col items-center gap-xl px-md tablet:w-[328px] tablet:px-0 desktop:w-[299px] desktop-l:w-[437px] desktop-l:gap-2xl desktop-xl:w-[598px]"
    >
        <span class="inline-flex aspect-square w-[88px] desktop:w-[168px]"
            ><LazyIcon class="h-[160px]" {icon} /></span
        >
        <div class="flex flex-col items-center gap-sm tablet:gap-md desktop-l:gap-lg">
            <span
                class="text-h-md text-center text-purple-100 tablet:text-h-xl desktop-l:text-h-2xl"
            >
                {title}
            </span>
            <span class="text-center text-sm text-grey-50 desktop-l:text-base">{info}</span>
        </div>
        {#if buttonText && href}
            <a {href} data-sveltekit-reload>
                <Button primary={true} theme="light-strong">{buttonText}</Button>
            </a>
        {/if}
    </div>
</div>
